<template>
    <div :class="['d-flex','flex-row',...classes]">
        <img :src="src">
        <strong class="m-0">{{ extra }}</strong>
    </div>
</template>
    
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
@Component({})
export default class DeviceDataIcon extends Vue {
    @Prop(Array) readonly classes!: string[]
    @Prop(String) readonly src!: string
    @Prop(String) readonly extra!: string
}
</script>

<style lang="sass" scoped>
.icon-data
  height: 20px
  display: flex
  padding: 2px 5px
  border-radius: 5px
  margin-right: 3px
  align-items: center
  justify-content: center
  img
    height: 100%
.icon-data:last-child
  margin-right: 0px !important
.key-green
  background: #DBEFDC
  padding: 5.5px

.charge
  background: #DBEFDC
  img
    height: 22px
.key-red
  background: #EFDBDB
  padding: 5.5px
.locked-car
  background: #EFDBDB
  padding: 4px 5px
.battery-gps
  background: #DBDDEF
  strong
    color: #2854EF
    font-size: 12px
  img
    margin-right: 4px
</style>
    